/* Kkumi shared DOM element builder (JS side).
 *
 * ONE canonical el(tag, cls, text) so asset scripts that build markup at
 * runtime don't each re-roll it. Loaded head-defer from theme.liquid before
 * the section scripts that use it, so `var el = window.KKEl;` is always ready.
 *
 * Usage (inside a section IIFE):  var el = window.KKEl;
 *   container.appendChild(el('p', 'kk-note', 'Hello'));   // class + text optional
 */
(function () {
  if (window.KKEl) return;
  window.KKEl = function (tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  };
})();
